import inputData from './inputData/event-signup-form';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'event-signup-form',
  title: 'Event Signup Form',
  description: 'Increase attendance and easily collect the key details you need from every guest.',
  image: '/images/templates/event-signup-form.png',
  tags: ['plan-events', 'engage-audience', 'lead-generation'],
  inputData: inputData,
  popular: true,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

